module.exports = __webpack_public_path__ + "static/media/DsFile.0752d124.svg";